import { render, staticRenderFns } from "./ManageManufacturers.vue?vue&type=template&id=0d87b621"
import script from "./ManageManufacturers.vue?vue&type=script&lang=ts"
export * from "./ManageManufacturers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports